"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const form_radio_module_scss_1 = __importDefault(require("./form-radio.module.scss"));
const FormRadio = ({ formRadioClassName, isDisabled, name, id, label, ariaLabel, showAriaLabel = true, value, selectedValue, subContent, subContentClassName, handleInputChange = () => { }, selectedClassName, formRadioDefaultBtnClassName, isDisabledClassName, ...other }) => {
    const selected = selectedValue == value;
    const selectedClass = (0, classnames_1.default)({
        [selectedClassName]: selectedClassName && selected,
        [form_radio_module_scss_1.default['is-selected']]: selected,
    });
    const formRadioClassNames = (0, classnames_1.default)(formRadioClassName, form_radio_module_scss_1.default["formRadio"], selectedClass);
    const isAriaLabel = showAriaLabel
        ? { 'aria-label': ariaLabel || label }
        : {};
    const defaultBtnClasses = (0, classnames_1.default)(form_radio_module_scss_1.default['formRadioBtn'], formRadioDefaultBtnClassName, {
        isDisabledClassName: isDisabled,
        [form_radio_module_scss_1.default['is-disabled']]: isDisabled,
    });
    const formRadioLabelClassName = (0, classnames_1.default)({ [`${formRadioClassName}__label`]: formRadioClassName }, form_radio_module_scss_1.default['formRadio__label']);
    const formRadioDefaultBtnInputClassName = (0, classnames_1.default)({
        [`${formRadioDefaultBtnClassName}__input`]: formRadioDefaultBtnClassName,
    }, form_radio_module_scss_1.default['formRadioBtn__input'], selectedClass);
    const formRadioDefaultBtnLabelClassName = (0, classnames_1.default)({
        [`${formRadioDefaultBtnClassName}__label`]: formRadioDefaultBtnClassName,
    }, form_radio_module_scss_1.default['formRadioBtn__label']);
    return ((0, jsx_runtime_1.jsxs)("div", { className: formRadioClassNames, children: [(0, jsx_runtime_1.jsxs)("label", { htmlFor: id, className: formRadioLabelClassName, ...other, ...isAriaLabel, children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", name: name, id: id, disabled: isDisabled, defaultValue: value, defaultChecked: selected, onChange: handleInputChange }), other.children ? (react_1.default.cloneElement(other.children, {
                        className: selectedClass,
                        isSelected: selected
                    })) : ((0, jsx_runtime_1.jsxs)("div", { className: defaultBtnClasses, children: [(0, jsx_runtime_1.jsx)("div", { className: formRadioDefaultBtnInputClassName }), (0, jsx_runtime_1.jsx)("div", { className: formRadioDefaultBtnLabelClassName, children: label })] }))] }), subContent && ((0, jsx_runtime_1.jsx)("div", { className: subContentClassName, children: subContent }))] }));
};
FormRadio.propTypes = {
    /** Applies a custom class to the FormRadio component and build the label classsname as well. */
    formRadioClassName: prop_types_1.default.string,
    /** Applies a custom class to the FormRadio component when is selected. */
    selectedClassName: prop_types_1.default.string,
    /** Applies a custom class to the default button on FormRadio component when no children passed, and build the input and label classnanes as well. */
    formRadioDefaultBtnClassName: prop_types_1.default.string,
    /** Applies a custom class to the label on FormRadio component. */
    formRadioLabelClassName: prop_types_1.default.string,
    /** Applies a custom class to the FormRadio component when is disabled. */
    isDisabledClassName: prop_types_1.default.string,
    /** Applies a disabled state to the FormRadio. */
    isDisabled: prop_types_1.default.bool,
    /** Input name attribute for the FormRadio. */
    name: prop_types_1.default.string.isRequired,
    /** Input id attribute for the FormRadio. */
    id: prop_types_1.default.string,
    /** Input value attribute for the FormRadio. */
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]).isRequired,
    /** Input selectedValue attribute for the FormRadio. */
    selectedValue: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    /** Shows aria-label attribute on the FormRadio. */
    showAriaLabel: prop_types_1.default.bool,
    /** Aria-label attribute value for the FormRadio. */
    ariaLabel: prop_types_1.default.string,
    /** Label for the FormRadio. */
    label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]).isRequired,
    /** Applies a children node as subcontent on the FormRadio*/
    subContent: prop_types_1.default.node,
    /** Applies a custom class to the SubContent on the FormRadio component. */
    subContentClassName: prop_types_1.default.string,
    /** A method used to handle changes on the input value. */
    handleInputChange: prop_types_1.default.func,
};
exports.default = FormRadio;
//# sourceMappingURL=form-radio.js.map